export default "__VITE_ASSET__Vc86zsoa__"